export enum DisplayPosition {
    THIRDPERSON_RIGHTHAND = "thirdperson_righthand",
    THIRDPERSON_LEFTHAND = "thirdperson_lefthand",
    FIRSTPERSON_RIGHTHAND = "firstperson_righthand",
    FIRSTPERSON_LEFTHAND = "firstperson_lefthand",
    GUI = "gui",
    HEAD = "head",
    GROUND = "ground",
    FIXED = "fixed",
    ON_SHELF = "on_shelf",
}

export const DISPLAY_POSITIONS = Object.values(DisplayPosition);
